/**
 * 文件说明:
 *
 * Page tabs Header
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import {memo, cloneElement, useState, isValidElement, useLayoutEffect} from 'react'
import ContentTabs from 'components/hz-layout/content-tabs'
import {clone} from 'lodash'
import {useRefData} from 'hooks'
import {tabsContext, useTabsContext} from './context'

export const ContentComponentWrap = memo((props) => {
    const {TabContent, tabContentOption: initTabContentOption, ...restProps} = props

    const {
        setHzHeaderHelp,
        pageHeaderOption,
        setPageHeaderOption,
        pageProps,
        restoreHzHeaderHelp,
        useTitle,
    } = useTabsContext()

    const [tabContentOption, setTabContentOption] = useState(() => {
        const newTabContentOption = clone(initTabContentOption)

        if (typeof newTabContentOption?.title === 'function') {
            newTabContentOption.title = newTabContentOption.title({
                pageProps,
                pageHeaderOption,
                tabContentOption: newTabContentOption,
            })
        }

        return newTabContentOption
    })

    const {hzHelp, title, defaultTitle} = tabContentOption

    const getRefData = useRefData({
        setHzHeaderHelp,
        restoreHzHeaderHelp,
        hzHelp,
    })

    useLayoutEffect(() => {
        getRefData()?.setHzHeaderHelp?.(getRefData()?.hzHelp)
        return () => {
            getRefData()?.restoreHzHeaderHelp?.()
        }
    }, [])

    const hzDocTitle = useTitle(title, defaultTitle)

    return isValidElement(TabContent) ? (
        cloneElement(TabContent, {
            ...TabContent.props,
            ...restProps,
            tabContentOption,
            setHzHeaderHelp,
            hzDocTitle,
            setTabContentOption,
            pageProps,
            pageHeaderOption,
            setPageHeaderOption,
        })
    ) : (
        <TabContent
            {...restProps}
            tabContentOption={tabContentOption}
            hzDocTitle={hzDocTitle}
            setHzHeaderHelp={setHzHeaderHelp}
            setTabContentOption={setTabContentOption}
            pageProps={pageProps}
            pageHeaderOption={pageHeaderOption}
            setPageHeaderOption={setPageHeaderOption}
        />
    )
})

const HzContentTabs = memo((props) => {
    const {
        pageHeaderOption: initPageHeaderOption,
        setHzHeaderHelp,
        pageProps,
        PageComponent,
        restoreHzHeaderHelp,
        useTitle,
    } = props

    const [pageHeaderOption, setPageHeaderOption] = useState(() => {
        const newPageHeaderOption = clone(initPageHeaderOption ?? {})

        newPageHeaderOption.content =
            newPageHeaderOption?.content?.map((item) => {
                const {content: TabContent, ...restItems} = item
                return {
                    content: (
                        <ContentComponentWrap tabContentOption={item} TabContent={TabContent} />
                    ),
                    ...restItems,
                }
            }) ?? []

        return newPageHeaderOption
    })

    return (
        <tabsContext.Provider
            value={{
                setHzHeaderHelp,
                pageProps,
                pageHeaderOption,
                setPageHeaderOption,
                restoreHzHeaderHelp,
                useTitle,
            }}
        >
            <PageComponent
                {...pageProps}
                setHzHeaderHelp={setHzHeaderHelp}
                restoreHzHeaderHelp={restoreHzHeaderHelp}
                pageHeaderOption={pageHeaderOption}
                setPageHeaderOption={setPageHeaderOption}
                ContentTabsComponent={ContentTabs}
                contentTabsComponentOption={{
                    location: pageProps.location,
                    ...pageHeaderOption,
                }}
            />
        </tabsContext.Provider>
    )
})

export default HzContentTabs
